import { isInvalidPurchaseOrderNumber, isInvalidCancellationReason } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { ReviewPurchaseOrderConfirmationFormDataKey } from "src/types";

class ReviewPurchaseOrderConfirmationFormValidator extends FormValidator {
  private static validatePurchaseOrderNumber(value: unknown): ValidationError<"purchaseOrderId"> | undefined {
    return isInvalidPurchaseOrderNumber(value)
      ? new ValidationError("Enter a valid purchase order number (e.g., 'PO-2055')", "purchaseOrderId")
      : undefined;
  }

  private static validateCancellationReason(value: unknown): ValidationError<"cancellationReason"> | undefined {
    return isInvalidCancellationReason(value?.toString())
      ? new ValidationError("Enter a valid cancellation reason", "cancellationReason")
      : undefined;
  }

  private static validateCreateBackorderPO(value: unknown): ValidationError<"createBackorderPO"> | undefined {
    // Boolean checkbox - no validation needed
    return undefined;
  }

  private static readonly validationStrategies: Record<
    ReviewPurchaseOrderConfirmationFormDataKey,
    (inputValue: unknown) => ValidationError<ReviewPurchaseOrderConfirmationFormDataKey> | undefined
  > = {
    purchaseOrderId: ReviewPurchaseOrderConfirmationFormValidator.validatePurchaseOrderNumber,
    cancellationReason: ReviewPurchaseOrderConfirmationFormValidator.validateCancellationReason,
    createBackorderPO: ReviewPurchaseOrderConfirmationFormValidator.validateCreateBackorderPO
  };

  static validatePurchaseOrderFormData<T extends ReviewPurchaseOrderConfirmationFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(
      formData,
      ReviewPurchaseOrderConfirmationFormValidator.validationStrategies
    ) as ValidationErrors<T>;
  }
}

export { ReviewPurchaseOrderConfirmationFormValidator };
